import shortenString from './shorten-string'

export default function displayProfileName (firstName, maxCharacters = 16) {
  let names = firstName.split(' ')
  let displayedName = ''

  if (names[0].length >= maxCharacters) return shortenString(names[0], maxCharacters)

  for (const name of names) {
    if ((name + displayedName).length >= maxCharacters + 1) break

    displayedName += `${name} `
  }

  return displayedName.slice(0, -1)
}
